import React from 'react';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { noop } from 'ui-components/default-props/noop';

import style from './delete-package-set-modal.module.css';
import { messages } from './messages';

type DeletePackageSetModalProps = {
  onDeletePackageSet?: () => void;
};

export const DeletePackageSetModal = ({ onDeletePackageSet = noop }: DeletePackageSetModalProps) => {
  return (
    <Modal className={style['delete-package-set-modal']}>
      <ModalHeader>
        <FormattedMessage {...messages.deletePackageSetModalTitle} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['modal-text']}>
          <FormattedMessage {...messages.deletePackageSetModalText} />
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <ModalFooterCancelButton />
        <Button onClick={onDeletePackageSet} theme='primary'>
          <FormattedMessage {...messages.multiPackageDeleteSetButton} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};
